<template>
  <div class="brandIncreasePage purchasePage">
    <!-- <div class="banner">
        <img src="./images/brandIncrease_banner.png" alt="">
      </div> -->
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon3">
        <i class="iconfont icon-pinpaizichanpingtai"></i>
      </div>
      <div class="breadcrumb_item">商务&销售管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">采购管理</div>
    </div>

    <!-- <div class="input_box search"> -->
    <!-- <van-field v-model="searchTxt" ref="input" placeholder="输入品牌关键字查找→" @focus="inputFocus" @blur="inputBlur" />
      </div> -->

    <div class="main_content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="initData"
        >
          <div class="data_list">
            <div class="item_card" v-for="item in dataList" :key="item.id">
              <div class="txt1">采购订单号：{{ item.ID }}</div>
              <div class="txt1">商品名称：{{ detail.commodityname }}</div>
              <div class="txt1">SKU编码：{{ detail.sku }}</div>
              <div class="txt1">ISBN编码：{{ detail.ISBN }}</div>
              <div class="txt1">品牌（出版商）：{{ detail.brandName }}</div>
              <div class="txt1">属性标签：{{ item.Tags }}</div>
              <div class="txt1">属性值：{{ item.TagValues }}</div>
              <div class="txt1">采购数量：{{ item.Quantity }}</div>
              <div class="txt1">采购金额：{{ item.Amount }}</div>
              <div class="txt1">已入库数量：{{ item.QuantityReceived }}</div>
              <div class="txt1">
                采购付款形式：{{
                  item.PaymentMethod == 1 ? "先款后货" : "货到付款"
                }}
              </div>
              <div class="operaton flex-rowr">
                <div
                  class="operation_item"
                  :class="{ active: item.ManagerApproval != 1 }"
                  @click="handleCheckPuracsh(item.ID, item.ManagerApproval)"
                  v-if="spAuth.isViewrange"
                >
                  {{
                    item.ManagerApproval == 1
                      ? "审核通过"
                      : item.ManagerApproval == 2
                      ? "审核不通过"
                      : "待审核"
                  }}
                </div>
                <div
                  class="operation_item active"
                  @click="handleToast"
                  v-if="zfAuth.isViewrange"
                >
                  待支付
                </div>
                <div
                  class="operation_item"
                  @click="handleWare(item.ID)"
                  v-if="rkglAuth.isViewrange"
                >
                  入库管理
                </div>
              </div>
            </div>

            <div class="return-fixd">
              <div
                class="primary-button"
                @click="handleGo()"
                v-if="cgsqAuth.isViewrange"
              >
                +发起采购申请
              </div>

              <div class="primary-button return" @click="handleReturn">
                <i class="iconfont icon-yuyinjiantou"></i> 返回
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>

    <van-dialog
      v-model="isShow"
      title="请选择审核状态"
      show-cancel-button
      :before-close="onBeforeClose"
      @confirm="checkPurchase"
    >
      <div class="dialog_wrappe flex-around">
        <van-radio-group v-model="ManagerApproval" direction="horizontal">
          <van-radio name="1">审核通过</van-radio>
          <van-radio name="2">审核不通过</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  getMenuAuthThree,
  getBrandList,
  getPurchaseList,
  checkPurchase,
} from "../../api/api";
import { mapState } from "vuex";
import storage from "../../utils/storage";
export default {
  name: "pManageList",
  data() {
    return {
      // 发起采购申请权限
      cgsqAuth: "",
      // 入库管理权限
      rkglAuth: "",
      // 待审批
      spAuth: "",
      // 待支付
      zfAuth: "",

      searchTxt: "",
      detail: "",

      qyid: "",

      brandList: "",
      dataList: [],
      loading: false,
      finished: false,
      refreshing: false,
      params: {
        page: 0,
        pagesize: 10,
        keyword: "",
        openid: "",
        opentype: "accountid", // 申请人的用户类型 = weixin 微信用户，qiye 企业用户 houtai 后台用户 accountid 用户账户id
      },

      // 采购
      isShow: false,
      purchaseId: "",
      ManagerApproval: "",
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO"]),
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.qyid = userInfo.qy.id;
    } else {
      this.qyid = 0;
    }

    this.detail = storage.get("GOODDETAIL");
    this.params.keyword = this.$route.params.keyword;
    this.params.openid = this.OPENID;

    this.getMenuAuthThree();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthThree() {
      let menuItem = this.$store.state.menuItem;
      let roleId = this.$store.state.USERINFO.qy.roleid;
      getMenuAuthThree(menuItem.id).then((res) => {
        if (res.length === 0) return;
        res.forEach((item) => {
          if (item.funcname === "发起采购申请按钮") {
            // 是否预览权限
            item.isViewrange = item.viewrange.split(",").indexOf(roleId) != -1;
            // 是否操作权限
            item.isDorange = item.dorange.split(",").indexOf(roleId) != -1;
            this.cgsqAuth = item;
          }
          if (item.funcname === "入库管理") {
            // 是否预览权限
            item.isViewrange = item.viewrange.split(",").indexOf(roleId) != -1;
            // 是否操作权限
            item.isDorange = item.dorange.split(",").indexOf(roleId) != -1;
            this.rkglAuth = item;
          }
          if (item.funcname === "待审批（采购计划状态）") {
            // 是否预览权限
            item.isViewrange = item.viewrange.split(",").indexOf(roleId) != -1;
            // 是否操作权限
            item.isDorange = item.dorange.split(",").indexOf(roleId) != -1;
            this.spAuth = item;
          }
          if (item.funcname === "待支付（采购计划状态）") {
            // 是否预览权限
            item.isViewrange = item.viewrange.split(",").indexOf(roleId) != -1;
            // 是否操作权限
            item.isDorange = item.dorange.split(",").indexOf(roleId) != -1;
            this.zfAuth = item;
          }
        });
      });
    },

    // 初始化采购列表
    initData() {
      let { params } = this;
      params.page++;
      params.t = new Date();
      getPurchaseList(params).then((res) => {
        this.dataList = this.dataList.concat(...res);
        // Toast.clear()
        // 加载状态结束
        this.loading = false;
        if (res.length < params.pagesize) {
          this.finished = true;
        }
      });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.params.page = 0;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.initData();
    },

    // 采购主管审核采购列表
    handleCheckPuracsh(id, type) {
      let { spAuth } = this;
      if (!spAuth.isDorange) {
        this.$message.warning("暂无权限");
        return;
      }
      if (type == 1) {
        return;
      }
      this.purchaseId = id;
      this.isShow = true;
    },
    onBeforeClose(action, done) {
      if (action === "confirm") {
        return done(false);
      } else {
        return done();
      }
    },
    checkPurchase() {
      let userInfo = this.USERINFO;
      let { purchaseId, ManagerApproval } = this;
      if (ManagerApproval == "") {
        this.$message.warning("请选择状态");
        return;
      }
      let params = {
        id: purchaseId,
        ManagerApproval: ManagerApproval,
        ManagerOpenID: userInfo.openid,
      };
      checkPurchase(params).then((res) => {
        console.log(res);
      });
    },
    // 入库管理
    handleWare(id) {
      let { rkglAuth } = this;
      if (!rkglAuth.isDorange) {
        this.$message.warning("暂无权限");
        return;
      }
      this.$router.push(`${rkglAuth.pagepath}/${id}`);
    },

    // 品牌标签
    getBrand(id) {
      const Toast = this.$message.warning.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let { qyid } = this;
      getBrandList({ qyid }).then((res) => {
        res.forEach((v) => {
          if (v.id == id) {
            this.detail.brandName = v.labelname;
          }
        });
        Toast.clear();
      });
    },

    handleToast() {
      let { zfAuth } = this;
      if (!zfAuth.isDorange) {
        this.$message.warning("暂无权限");
        return;
      }
      this.$message.warning("即将开放");
    },

    handleReturn() {
      history.back();
      storage.remove("GOODDETAIL");
    },
    handleGo() {
      let { cgsqAuth } = this;
      if (!cgsqAuth.isDorange) {
        this.$message.warning("暂无权限");
        return;
      }
      this.$router.push(cgsqAuth.pagepath);
    },
  },
};
</script>
<style lang="less" scoped>
.brandIncreasePage {
  padding-bottom: 400px;
  .input_box.search {
    margin-bottom: 60px;
  }
  .noData p {
    text-align: center;
    font-size: 28px;
    color: #aaaaaa;
    padding: 150px 0;
  }
  .item_card {
    width: 650px;
    margin: 0 auto 60px;
    padding: 45px 37px 47px;
    position: relative;
    border: 2px solid #dedede;
    border-radius: 30px;
    box-sizing: border-box;
    margin-bottom: 60px;
    .title {
      font-size: 30px;
      color: #404d6c;
      p {
        font-size: 22px;
        margin-top: 20px;
      }
    }
    .img {
      width: 250px;
      height: 250px;
      margin: 80px auto 50px;
      overflow: hidden;
      background: #fbf8ef;
      img {
        width: 100%;
      }
    }
    .txt1 {
      font-size: 26px;
      color: #404d6c;
      margin-bottom: 10px;
    }
    .txt2 {
      font-size: 26px;
      color: #444444;
      font-weight: bold;
      margin-bottom: 10px;
      span {
        font-size: 26px;
        color: #f40728;
        font-weight: 400;
      }
    }
    .operaton {
      margin-top: 40px;
      .operation_item {
        padding: 10px 30px;
        border-radius: 45px;
        border: 1px solid #dedede;
        font-size: 24px;
        margin-left: 30px;
        color: #404d6c;
        &.active {
          color: #f62560;
        }
      }
    }
  }

  .dialog_wrappe {
    margin: 50px 0;
  }
}
</style>